module.exports = __webpack_public_path__ + "media/images/team__crushersgc-754020b1a4db5c6e20fb2b795ebeab39.png";